import clsx from "clsx";
import { Link } from "react-router-dom";
import s from "./Btn.module.scss";

type ButtonHeight = "small" | "auto" | string;
type ButtonWidth = "auto" | string;

interface Props {
  children?: React.ReactNode;
  className?: string;
  href?: string;
  blank?: boolean;
  type?:
    | "white"
    | "grey"
    | "clear"
    | "disabled"
    | "default"
    | "light-grey"
    | "submit";
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  height?: ButtonHeight;
  width?: ButtonWidth;
  fontSize?: string;
  fontWeight?: string;
  disabled?: boolean;
  padding?: React.CSSProperties["padding"];
  isLoading?: boolean;
}

const getHeightStyle = (height: ButtonHeight) =>
  ({
    small: "45px",
    auto: "100%",
  }[height] || `${height}px`);

const getWidthStyle = (width: ButtonWidth) =>
  ({
    auto: "100%",
    full: "100%",
  }[width] || `${width}px`);

const Btn: React.FC<Props> = ({
  children,
  className,
  href,
  blank,
  type = "default",
  onClick,
  height = "52",
  width = "full",
  fontSize = "16",
  fontWeight = "700",
  disabled = false,
  isLoading = false,
  padding,
}) => {
  const style = {
    height: getHeightStyle(height),
    width: getWidthStyle(width),
    fontSize: `${fontSize}px`,
    fontWeight: fontWeight,
    padding,
  };

  const classes = clsx(
    s.btn,
    {
      [s.default]: type !== "clear" && type,
      [s.disabled]: disabled || type === "disabled",
      [s.whiteColor]: type === "white",
      [s.grey]: type === "grey",
      [s.light_grey]: type === "light-grey",
    },
    className
  );

  const anchorProps = {
    onClick,
    className: classes,
    style: style,
    ...(blank && { target: "_blank", rel: "noopener noreferrer" }),
  };

  return href ? (
    <Link to={href} {...anchorProps}>
      <button
        disabled={disabled || isLoading}
        type={type === "submit" ? "submit" : "button"}
      >
        {children}
      </button>
    </Link>
  ) : (
    <button
      disabled={disabled || isLoading}
      type={type === "submit" ? "submit" : "button"}
      {...anchorProps}
    >
      {children}
    </button>
  );
};

export default Btn;
